<template>
  <div class="aspect-ratio-parent">
    <div class="aspect-ratio-container" :style="aspectPadding">
      <div class="aspect-ratio-inner">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AspectRatio',

  props: {
    w: {
      type: Number,
      default: 1,
    },

    h: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    aspectPadding() {
      const percent = this.h / this.w * 100.0;
      return `padding-top: ${percent}%;`;
    },
  },
};
</script>

<style lang="scss">
  .aspect-ratio-container {
    height: 0;
    overflow: hidden;
    position: relative;

    &>.aspect-ratio-inner {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
